import { render, staticRenderFns } from "./myFile.vue?vue&type=template&id=3a53dab0&scoped=true"
import script from "./myFile.vue?vue&type=script&lang=js"
export * from "./myFile.vue?vue&type=script&lang=js"
import style0 from "./myFile.vue?vue&type=style&index=0&id=3a53dab0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53dab0",
  null
  
)

export default component.exports